"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PORTAL_FEED_REFUSALS = exports.zShoutoutParams = exports.SHOUTOUT_KINDS = void 0;
const zod_1 = require("zod");
/**
 * Shoutouts — the venue's social feed (SPEC §9, PORTAL-RESEARCH §3).
 *
 * NOT EXPORTED FROM THE INDEX until the backend lands; this file is the
 * contract written ahead of the build, the same way `engagement.ts` was.
 *
 * Two properties carry over from the schema and must survive the wire:
 *
 * 1. **Generated, never authored.** There is no "post" input anywhere in this
 *    file, and there must never be one. The feed can only say what happened.
 * 2. **Parameters, not sentences.** A shoutout crosses the wire as `kind` +
 *    typed params and each client renders it in the reader's language. A
 *    server-rendered sentence would freeze in whichever language generated it.
 */
exports.SHOUTOUT_KINDS = [
    'FIRST_LOGIN',
    'LOGIN_STREAK',
    'POINTS_MILESTONE',
    'PRIZE_REDEEMED',
    'MEMBER_MILESTONE',
    'CHALLENGE_RESULT',
];
/**
 * The template parameters per kind — the discriminated shape of the `payload`
 * column. `zShoutoutParams` is what the API validates before storing and what
 * the portal validates after fetching, so a malformed row is caught at the
 * boundary instead of rendering as "undefined".
 */
exports.zShoutoutParams = zod_1.z.discriminatedUnion('kind', [
    zod_1.z.object({ kind: zod_1.z.literal('FIRST_LOGIN') }),
    zod_1.z.object({ kind: zod_1.z.literal('LOGIN_STREAK'), days: zod_1.z.number().int().min(2) }),
    zod_1.z.object({ kind: zod_1.z.literal('POINTS_MILESTONE'), points: zod_1.z.number().int().min(1) }),
    zod_1.z.object({
        kind: zod_1.z.literal('PRIZE_REDEEMED'),
        points: zod_1.z.number().int().min(1),
        prizeName: zod_1.z.string().min(1).max(120),
    }),
    zod_1.z.object({ kind: zod_1.z.literal('MEMBER_MILESTONE'), members: zod_1.z.number().int().min(1) }),
    zod_1.z.object({
        kind: zod_1.z.literal('CHALLENGE_RESULT'),
        challengeTitle: zod_1.z.string().min(1).max(120),
        /** Ties are real (PORTAL-RESEARCH §3.1 #6) — always a list. */
        winners: zod_1.z.array(zod_1.z.string().min(1).max(120)).min(1).max(20),
    }),
]);
/** Refusals the feed screen must discriminate on. */
exports.PORTAL_FEED_REFUSALS = [
    'shoutout_not_found',
    /** You cannot high five your own shoutout. */
    'own_shoutout',
    /** Walk-ins read the feed; reacting needs an account (§3.2 guest state). */
    'account_required',
    /** High-five-back is the subject's action; nobody else can respond. */
    'not_the_subject',
];
//# sourceMappingURL=shoutouts.js.map